import React, { useState, useEffect, useCallback, useRef } from 'react';
import "./style.scss";
import { NavLink } from "react-router-dom";
import logo from '../../Logo/logo_m_red.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faGlobe } from '@fortawesome/free-solid-svg-icons';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import Flag from 'react-flagkit'; // Import de Flag

export default function Header() {
  const { t } = useTranslation();
  const sidemenuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [areFlagsVisible, setFlagsVisible] = useState(false); // Nouvel état pour l'affichage des drapeaux
  const [selectedLanguage, setSelectedLanguage] = useState('FR');

  const openMenu = () => {
    if (sidemenuRef.current) {
      setIsMenuOpen(true);
      sidemenuRef.current.style.right = "0";
    }
  };

  const closeMenu = useCallback(() => {
    if (sidemenuRef.current) {
      setIsMenuOpen(false);
      sidemenuRef.current.style.right = "-200px";
    }
  }, []);

  const handleClickOutside = useCallback((event) => {
    if (sidemenuRef.current && !sidemenuRef.current.contains(event.target)) {
      closeMenu();
    }
  }, [closeMenu]);

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen, handleClickOutside]);

  const changeLanguage = (lang) => {
    setSelectedLanguage(lang);
    i18next.changeLanguage(lang);
    setFlagsVisible(false); // Optionnel : ferme les drapeaux après sélection
  };

  const toggleFlags = () => {
    setFlagsVisible(!areFlagsVisible);
  };

  return (
    <div id="header">
      <div className="container">
        <nav>
          <header>
            <NavLink to="/">
              <img src={logo} className="logo" alt="Logo" />
            </NavLink>
            <ul id="sidemenu" ref={sidemenuRef} className={isMenuOpen ? 'open' : ''}>
              <li>
                <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>{t('nav.home')}</NavLink>
              </li>
              <li>
                <NavLink to="/Competence" className={({ isActive }) => (isActive ? "active" : "")}>{t('nav.competences')}</NavLink>
              </li>
              <li>
                <NavLink to="/Portfolio" className={({ isActive }) => (isActive ? "active" : "")}>{t('nav.portfolio')}</NavLink>
              </li>
              <li>
                <NavLink to="/Contact" className={({ isActive }) => (isActive ? "active" : "")}>{t('nav.contact')}</NavLink>
              </li>
              <li>
                <NavLink to="/AssistantIA" className={({ isActive }) => (isActive ? "active" : "")}>{t('nav.assistantIA')}</NavLink>
              </li>
              <FontAwesomeIcon icon={faTimes} className="fa-solid fa-xmark" onClick={() => closeMenu()} />
            </ul>
            <div className="language-selector">
              <FontAwesomeIcon
                icon={faGlobe}
                className="globe-icon"
                title={t('nav.languageSelector')}
                onClick={toggleFlags} // Gestion de l'affichage des drapeaux
              />
              <div className={`flags-container ${areFlagsVisible ? 'show' : ''}`}>
                <span
                  className={`flag-icon ${selectedLanguage === 'AR' ? 'active' : ''}`}
                  onClick={() => changeLanguage('AR')}
                  title="Arabe"
                >
                  <Flag country="MA" />
                </span>
                <span
                  className={`flag-icon ${selectedLanguage === 'FR' ? 'active' : ''}`}
                  onClick={() => changeLanguage('FR')}
                  title="Français"
                >
                  <Flag country="FR" />
                </span>
                <span
                  className={`flag-icon ${selectedLanguage === 'EN' ? 'active' : ''}`}
                  onClick={() => changeLanguage('EN')}
                  title="Anglais"
                >
                  <Flag country="GB" />
                </span>
                <span
                  className={`flag-icon ${selectedLanguage === 'ES' ? 'active' : ''}`}
                  onClick={() => changeLanguage('ES')}
                  title="Espagnol"
                >
                  <Flag country="ES" />
                </span>
              </div>
            </div>
            <FontAwesomeIcon icon={faBars} className="fa-solid fa-bars" onClick={() => openMenu()} />
          </header>
        </nav>
      </div>
    </div>
  );
}
